export let RolesModalFieldsJSON = {
  "1692363731639-customSelect": {
    elementid: 1692363731639,
    elementtype: "customSelect",
    "display-required": 1,
    "database-label": "status",
    "data-datasource": "customvalues",
    "data-customvalue": "ACTIVE#INACTIVE",
    "display-fieldlabel": "Status",
    "display-noofcolumns": "2",
    "display-placeholder": "Select",
    "display-labelposition": "top",
  },
  "1692362019775-columns": {
    elementid: 1692362019775,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1692362079963-textfield": {
    elementid: 1692362079963,
    elementtype: "textfield",
    "display-required": 1,
    "display-fieldlabel": "Name",
    "database-label": "name",
    "display-placeholder": "Enter",
    "validation-maxlength": "50",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  },
  "1692362083195-textarea": {
    elementid: 1692362083195,
    elementtype: "textarea",
    "display-fieldlabel": "Description",
    "database-label": "description",
    "display-placeholder": "Enter",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
  },
  "1692363740621-customSelect": {
    elementid: 1692363740621,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": [],
    "display-fieldlabel": "Application",
    "database-label": "code",
    "display-labelposition": "top",
    "display-placeholder": "Select",
  },
};
